import Loading from './Loading';

Loading.install = function(Vue) {
  Vue.component(Loading.name, Loading);
};

export default Loading;
